import { fetchWholesaleOrderDetail, fetchWholesale, selectWholesale, resetCurrentWholesale } from '../../actions/wholesale_actions';
import { voidSalesOrder } from '../../actions/sales_actions';
import { connect } from 'react-redux';

import Wholesale from '../../components/Sales/wholesale'

function mapStateToProps(state) {
    return {
        currentWholesale: state.wholesale.currentWholesale,
        wholesale: state.wholesale.all,
        detailIsLoading: state.wholesale.detailIsLoading,
        detailError: state.wholesale.detailError,
        salesOrderDetail: state.wholesale.currentWholesaleDetail,
        salesOrderIsLoading: state.wholesale.detailIsLoading,
        salesOrderError: state.wholesale.detailError,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { voidSalesOrder,fetchWholesaleOrderDetail, fetchWholesale, selectWholesale, resetCurrentWholesale })(Wholesale);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/wholesale.jsx